module.exports = __webpack_public_path__ + "static/img/sound_jy.ff0708f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sound_jy.png
// module id = nY1R
// module chunks = 128